/**
 * @file GA4 client_id — lê cookie _ga ou gera fallback UUID.
 * @description Formato _ga: GA1.1.XXXXXXXXXX.YYYYYYYYYY → client_id = XXXXXXXXXX.YYYYYYYYYY
 */

const GA_COOKIE_RE = /^GA\d+\.\d+\.(\d+\.\d+)$/;

/** Extrai client_id de um valor de cookie _ga. */
export function parseGaClientIdFromCookie(cookieValue: string): string | null {
  const match = GA_COOKIE_RE.exec(cookieValue.trim());
  return match?.[1] ?? null;
}

function readGaCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const entry = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith('_ga='));
  if (!entry) return null;
  return decodeURIComponent(entry.slice(4));
}

/** Client_id GA4 para Measurement Protocol — cookie _ga ou UUID. */
export function getGaClientId(): string {
  const raw = readGaCookie();
  if (raw) {
    const parsed = parseGaClientIdFromCookie(raw);
    if (parsed) return parsed;
  }
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}.${Math.random().toString(36).slice(2, 11)}`;
}
